import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { DashboardCardService, DashboardKpiService, GungDashboardModule } from 'gung-dashboard'; // FilterCardService
import { GungListModule } from 'gung-list';
import {
  ActivityInternalListConfigService,
  AvailabilityHelperService,
  BackendInterceptor,
  BaseViewConfigService,
  CartConfigService,
  CheckoutConfigService,
  createTranslateLocalLoader,
  GungStandardModule,
  LoginConfigService,
  NavbarConfigService,
  OpenOrdersConfigService,
  OrderContextService,
  OrderListConfigService,
  PriceConfigService,
  ProductExportListConfigService,
  ProductInputQuantityConfigService,
  ProductListConfigService,
  ProductListV2ConfigService,
  SalesCartConfigService,
  TranslationLocalService,
  UsersService,
  GungModalService,
  CustomerContactListConfigService,
  ActivityInternalCustomerResponsibleService,
  ProductExportActionConfigService,
  DeliveryDateService
} from 'gung-standard';
import { GungStandardJeevesModule, JeevesDeliveryDateService, JeevesModalService, JeevesOrderActionConfigService } from 'gung-standard-jeeves';
import { environment } from '../environments/environment';
import { CultHomeComponent } from './components/cult-home/cult-home.component';
import { CultJeevesProductTableComponent } from './components/cult-jeeves-product-table/cult-jeeves-product-table.component';
import { CultNavbarComponent } from './components/cult-navbar/cult-navbar.component';
import { CultProductCardComponent } from './components/cult-product-card/cult-product-card.component';
import { CultWrapperComponent } from './components/cult-wrapper/cult-wrapper.component';
import { CultAppComponent } from './cult-app.component';
import { CultBackendInterceptorService } from './services/cult-backend-interceptor.service';
import { CultProductListConfigService } from './services/cult-product-list-config.service';
import { MatSidenavModule } from '@angular/material/sidenav';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { GungCommonModule } from 'gung-common';
import { JeevesOrderDetailsConfigService } from 'gung-standard-jeeves';
import { NgChartsModule } from 'ng2-charts';
import { NgxImageZoomModule } from 'ngx-image-zoom';
import { CultFilterCardComponent } from './components/cards/cult-filter-card/cult-filter-card.component';
import { CultMonthlyOrderSummaryComponent } from './components/cards/cult-monthly-order-summary/cult-monthly-order-summary.component';
import { CultOrderChartComponent } from './components/cards/cult-order-chart/cult-order-chart.component';
import { OrdersFilteredStatisticsComponent } from './components/cards/orders-filtered-statistics/orders-filtered-statistics.component';
import { CultCartListComponent } from './components/checkout/cult-cart-list/cult-cart-list.component';
import { CultCheckoutButtonsComponent } from './components/checkout/cult-checkout-buttons/cult-checkout-buttons.component';
import { CultCheckoutWrapperComponent } from './components/checkout/cult-checkout-wrapper/cult-checkout-wrapper.component';
import { AssignOrderRowsCultComponent } from './components/checkout/steps/assign-order-rows-cult/assign-order-rows-cult.component';
import { CultCartTotalStepComponent } from './components/checkout/steps/cult-cart-total-step/cult-cart-total-step.component';
import { CultCreateUnifaunReturnStepComponent } from './components/checkout/steps/cult-create-unifaun-return-step/cult-create-unifaun-return-step.component';
import { CultReturnInfoStepComponent } from './components/checkout/steps/cult-return-info-step/cult-return-info-step.component';
import { CultAddOrderRowModalComponent } from './components/cult-add-order-row-modal/cult-add-order-row-modal.component';
import { CultBuyBtnComponent } from './components/cult-buy-btn/cult-buy-btn.component';
import { CultCheckoutDefaultsComponent } from './components/cult-checkout-defaults/cult-checkout-defaults.component';
import { CultCustomerDetailsComponent } from './components/cult-customer-details/cult-customer-details.component';
import { CultDeliveryLocationsComponent } from './components/cult-delivery-locations/cult-delivery-locations.component';
import { CultLoginComponent } from './components/cult-login/cult-login.component';
import { CultNavbarCartComponent } from './components/cult-navbar-cart/cult-navbar-cart.component';
import { CultOrderCardListComponent } from './components/cult-order-card-list/cult-order-card-list.component';
import { CultOrderConfirmationComponent } from './components/cult-order-confirmation/cult-order-confirmation.component';
import { CultProductDetailsComponent } from './components/cult-product-details/cult-product-details.component';
import { CultProductGridCardV2Component } from './components/cult-product-grid-card-v2/cult-product-grid-card-v2.component';
import { CultRequestAccountComponent } from './components/cult-request-account/cult-request-account.component';
import { CultSalesCartListComponent } from './components/cult-sales-cart-list/cult-sales-cart-list.component';
import { CultSalesCartRowComponent } from './components/cult-sales-cart-row/cult-sales-cart-row.component';
import { CultSummarizeOrderComponent } from './components/cult-summarize-order/cult-summarize-order.component';
import { CultFlowDetailsBasicSettingsComponent } from './components/flow-details/cult-flow-details-basic-settings/cult-flow-details-basic-settings.component';
import { CultFlowDetailsComponent } from './components/flow-details/cult-flow-details/cult-flow-details.component';
import { CultAvailabilityHelperService } from './services/cult-availability-helper.service';
import { CultBaseViewConfigService } from './services/cult-base-view-config.service';
import { CultCartConfigService } from './services/cult-cart-config.service';
import { CultCheckoutConfigService } from './services/cult-checkout-config.service';
import { CultDashboardCardService } from './services/cult-dashboard-card.service';
import { CultNavbarConfigService } from './services/cult-navbar-config.service';
import { CultOpenOrderConfigService } from './services/cult-open-order-config.service';
import { CultOrderActionConfigService } from './services/cult-order-action-config.service';
import { CultOrderContextService } from './services/cult-order-context.service';
import { CultOrderDetailsConfigService } from './services/cult-order-details-config.service';
import { CultOrderListConfigService } from './services/cult-order-list-config.service';
import { CultProductExportListConfigService } from './services/cult-product-export-list-config.service';
import { CultProductInputQuantityConfigService } from './services/cult-product-input-quantity-config.service';
import { CultProductListV2ConfigService } from './services/cult-product-list-v2-config.service';
import { CultSalesCartConfigService } from './services/cult-sales-cart-config.service';
import { CultTranslationLocalService } from './services/cult-translation-local.service';
import { CultUsersService } from './services/cult-users.service';
import { CultOrderDetailsComponent } from './components/cult-order-details/cult-order-details.component';
import { CultLoginConfigService } from './services/cult-login-config.service';
import { CultUserDetailsComponent } from './components/cult-user-details/cult-user-details.component';
import { CultUserDetailsUserComponent } from './components/cult-user-details/cult-user-details-user/cult-user-details-user.component';
import { CultOrderTermsJeevesComponent } from './components/checkout/steps/cult-order-terms-jeeves/cult-order-terms-jeeves.component';
import { CultPriceConfigService } from './services/cult-price-config.service';
import { CultOpenOrdersTableComponent } from './components/cult-open-orders-table/cult-open-orders-table.component';
import { CultActivityInternalListConfigService } from './services/cult-activity-internal-list-config.service';
import { CultActivityInternalWrapperComponent } from './components/cult-activity-internal-wrapper/cult-activity-internal-wrapper.component';
import { CultActivityInternalCreateModalComponent } from './components/cult-activity-internal-create-modal/cult-activity-internal-create-modal.component';
import { CultGungModalService } from './services/cult-gung-modal.service';
import { CultProductExportCardComponent } from './components/cult-product-export-card/cult-product-export-card.component';
import { CultActivityInternalViewModalComponent } from './components/cult-activity-internal-view-modal/cult-activity-internal-view-modal.component';
import { CultActivityInternalTableComponent } from './components/cult-activity-internal-table/cult-activity-internal-table.component';
import { CultCustomerContactCardListComponent } from './components/cult-customer-contact-card-list/cult-customer-contact-card-list.component';
import { CultCustomerContactListConfigService } from './services/cult-customer-contact-list-config.service';
import { CultEditContactModalComponent } from './components/cult-edit-contact-modal/cult-edit-contact-modal.component';
import { CultJeevesModalService } from './services/cult-jeeves-modal.service';
import { CultAddContactModalComponent } from './components/cult-add-contact-modal/cult-add-contact-modal.component';
import { CultActivityInternalCustomerListConfigService } from './services/cult-activity-internal-customer-list-config.service';
import { CultLastVsThisMonthMeetingsAmountSummaryCardComponent } from './components/cult-last-vs-this-month-meetings-amount-summary-card/cult-last-vs-this-month-meetings-amount-summary-card.component';
import { CultMeetingsConvertedIntoSalesSummaryCardComponent } from './components/cult-meetings-converted-into-sales-summary-card/cult-meetings-converted-into-sales-summary-card.component';
import { CultSalesSummaryCardComponent } from './components/cult-sales-summary-card/cult-sales-summary-card.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { CultSalespersonSelectComponent } from './components/cult-salesperson-select/cult-salesperson-select.component';
import { CultInvoiceStatisticsChartCardComponent } from './components/cult-invoice-statistics-chart-card/cult-invoice-statistics-chart-card.component';
import { CultInvoiceStatisticsChartComponent } from './components/cult-invoice-statistics-chart/cult-invoice-statistics-chart.component';
import { CultActivityInternalCustomerResponsibleService } from './services/cult-activity-internal-customer-responsible.service';
import { CultLastVsThisYearSalesCardComponent } from './components/cards/cult-last-vs-this-year-sales-card/cult-last-vs-this-year-sales-card.component';
import { CultDashboardKpiService } from './services/cult-dashboard-kpi.service';
import { CultProductExportActionConfigService } from './services/cult-product-export-action-config.service';
import { CultCloudPimProductFieldsComponent } from './components/cult-cloud-pim-product-fields/cult-cloud-pim-product-fields.component';
import { CultDeliveryDateService } from './services/cult-delivery-date.service';

@NgModule({
  declarations: [
    CultAppComponent,
    CultJeevesProductTableComponent,
    CultWrapperComponent,
    CultNavbarComponent,
    CultProductCardComponent,
    CultHomeComponent,
    CultSalesCartListComponent,
    CultSalesCartRowComponent,
    CultProductDetailsComponent,
    CultDeliveryLocationsComponent,
    CultAddOrderRowModalComponent,
    CultSummarizeOrderComponent,
    CultMonthlyOrderSummaryComponent,
    CultOrderChartComponent,
    CultFilterCardComponent,
    OrdersFilteredStatisticsComponent,
    CultCheckoutDefaultsComponent,
    AssignOrderRowsCultComponent,
    CultCartTotalStepComponent,
    CultLoginComponent,
    CultRequestAccountComponent,
    CultNavbarCartComponent,
    CultReturnInfoStepComponent,
    CultCartListComponent,
    CultCreateUnifaunReturnStepComponent,
    CultCheckoutWrapperComponent,
    CultOrderConfirmationComponent,
    CultCheckoutButtonsComponent,
    CultOrderCardListComponent,
    CultProductGridCardV2Component,
    CultCustomerDetailsComponent,
    CultBuyBtnComponent,
    CultFlowDetailsBasicSettingsComponent,
    CultFlowDetailsComponent,
    CultOrderDetailsComponent,
    CultUserDetailsComponent,
    CultUserDetailsUserComponent,
    CultOrderTermsJeevesComponent,
    CultOpenOrdersTableComponent,
    CultActivityInternalWrapperComponent,
    CultActivityInternalCreateModalComponent,
    CultProductExportCardComponent,
    CultActivityInternalViewModalComponent,
    CultActivityInternalTableComponent,
    CultCustomerContactCardListComponent,
    CultEditContactModalComponent,
    CultAddContactModalComponent,
    CultLastVsThisMonthMeetingsAmountSummaryCardComponent,
    CultMeetingsConvertedIntoSalesSummaryCardComponent,
    CultSalesSummaryCardComponent,
    CultSalespersonSelectComponent,
    CultInvoiceStatisticsChartCardComponent,
    CultInvoiceStatisticsChartComponent,
    CultLastVsThisYearSalesCardComponent,
    CultCloudPimProductFieldsComponent
  ],
  bootstrap: [CultAppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    NgChartsModule,
    GungStandardModule,
    GungStandardJeevesModule,
    GungCommonModule,
    GungListModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    GungDashboardModule,
    MatSidenavModule,
    RouterModule,
    NgxImageZoomModule,
    MatPaginatorModule,
    MatTableModule,
    MatSortModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLocalLoader,
        deps: [TranslationLocalService]
      }
    })
  ],
  providers: [
    { provide: 'environment', useValue: environment },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CultBackendInterceptorService,
      multi: true
    },
    /* {
              provide: FilterCardService,
              useClass: CultFilterCardService
            }, */
    {
      provide: BackendInterceptor,
      useClass: CultBackendInterceptorService
    },
    {
      provide: ProductListConfigService,
      useClass: CultProductListConfigService
    },
    {
      provide: SalesCartConfigService,
      useClass: CultSalesCartConfigService
    },
    {
      provide: CheckoutConfigService,
      useClass: CultCheckoutConfigService
    },
    {
      provide: JeevesOrderDetailsConfigService,
      useClass: CultOrderDetailsConfigService
    },
    {
      provide: DashboardCardService,
      useClass: CultDashboardCardService
    },
    {
      provide: OpenOrdersConfigService,
      useClass: CultOpenOrderConfigService
    },
    {
      provide: TranslationLocalService,
      useClass: CultTranslationLocalService
    },
    {
      provide: ProductExportListConfigService,
      useClass: CultProductExportListConfigService
    },
    {
      provide: NavbarConfigService,
      useClass: CultNavbarConfigService
    },
    {
      provide: BaseViewConfigService,
      useClass: CultBaseViewConfigService
    },
    {
      provide: CartConfigService,
      useClass: CultCartConfigService
    },
    {
      provide: JeevesOrderActionConfigService,
      useClass: CultOrderActionConfigService
    },
    {
      provide: OrderListConfigService,
      useClass: CultOrderListConfigService
    },
    {
      provide: ProductListV2ConfigService,
      useClass: CultProductListV2ConfigService
    },
    {
      provide: OrderContextService,
      useClass: CultOrderContextService
    },
    {
      provide: AvailabilityHelperService,
      useClass: CultAvailabilityHelperService
    },
    {
      provide: UsersService,
      useClass: CultUsersService
    },
    {
      provide: ProductInputQuantityConfigService,
      useClass: CultProductInputQuantityConfigService
    },
    {
      provide: LoginConfigService,
      useClass: CultLoginConfigService
    },
    {
      provide: PriceConfigService,
      useClass: CultPriceConfigService
    },
    {
      provide: GungModalService,
      useClass: CultGungModalService
    },
    {
      provide: CustomerContactListConfigService,
      useClass: CultCustomerContactListConfigService
    },
    {
      provide: JeevesModalService,
      useClass: CultJeevesModalService
    },
    {
      provide: ActivityInternalListConfigService,
      useClass: CultActivityInternalCustomerListConfigService
    },
    {
      provide: ActivityInternalCustomerResponsibleService,
      useClass: CultActivityInternalCustomerResponsibleService
    },
    {
      provide: DashboardKpiService,
      useClass: CultDashboardKpiService
    },
    {
      provide: ProductExportActionConfigService,
      useClass: CultProductExportActionConfigService
    },
    {
      provide: DeliveryDateService,
      useClass: CultDeliveryDateService
    },
    {
      provide: JeevesDeliveryDateService,
      useClass: CultDeliveryDateService
    },
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class CultAppModule {}
